let uidIndex: number = 0;

function next() {
    return uidIndex++;
}

export default {
    next: next
};
